import { render, staticRenderFns } from "./EvolutionChart.vue?vue&type=template&id=058976b6"
import script from "./EvolutionChart.vue?vue&type=script&lang=js"
export * from "./EvolutionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports